import React from 'react';
import ContentViewModel from 'Shared/ViewModels/ContentViewModel.type';
import { styled, StyledProps } from '@glitz/react';
import { Preset, Ratio, RatioPicture } from 'Shared/Image/Ratio';
import Link from 'Shared/Link';
import { ArticleTag, ResponsiveSize, H2 } from 'Shared/SharedComponents/atoms/Typography';

type PropType = StyledProps & {
  cmsPage: ContentViewModel;
  isCompact: boolean;
  className?: string;
  breakPoint: number;
};

export default styled((props: PropType) => {
  const { cmsPage, isCompact } = props;
  return (
    <Link
      className={props.className}
      to={cmsPage.url}
      css={{
        textDecoration: 'none',
        color: 'black',
        width: '100%',
      }}
      draggable={false}
    >
      <RatioPicture
        src={cmsPage.image}
        title={cmsPage.title}
        alt={cmsPage.title}
        ratio={Ratio.FourToThree}
        preset={Preset.CmsListItem}
        borderRadius={8}
        css={{
          marginBottom: '16px',
        }}
      />
      <styled.Div
        css={{
          gap: '12px',
          ...(isCompact && {
            padding: {
              top: '0px',
              right: '16px',
              bottom: '0px',
              left: '0px',
            },
          }),
        }}
      >
        {cmsPage.articleTag && <ArticleTag upperCase shouldAlwaysClaimHeight>{cmsPage.articleTag}</ArticleTag>}
        <H2 upperCase={false} fontSize={ResponsiveSize.D24_M24} shouldAlwaysClaimHeight>
          {cmsPage.title}
        </H2>
        {cmsPage.articleTags?.length > 0 && (
          <ArticleTag upperCase shouldAlwaysClaimHeight>
            {cmsPage.articleTags?.slice(0, 3).join(', ')}
            {(cmsPage.articleTags?.length ?? 0) > 3 && `, +${cmsPage.articleTags?.length - 3}`}
          </ArticleTag>
        )}
      </styled.Div>
    </Link>
  );
});
